
import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from "@/components/ui/resizable";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import ReactMarkdown from "react-markdown";
import { questions, MLQuestion } from "@/pages/ml-fundamentals/questions";

const MLFundamentals = () => {
  const [selected, setSelected] = useState<MLQuestion>(questions[0]);

  useEffect(() => {
    document.title = "ML Fundamentals Interview Q&A | HelloML";
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow container py-6">
        <ResizablePanelGroup direction="horizontal" className="h-[70vh] rounded-md border">
          <ResizablePanel defaultSize={30} minSize={25} className="border-r">
            <ScrollArea className="h-full">
              <ul className="divide-y">
                {questions.map((q) => (
                  <li
                    key={q.id}
                    onClick={() => setSelected(q)}
                    className={`p-4 cursor-pointer transition-colors ${selected.id === q.id ? "bg-muted" : "hover:bg-muted/50"}`}
                  >
                    <p className="font-medium">{q.short}</p>
                    <div className="mt-2 flex flex-wrap gap-2 text-xs">
                      <Badge variant="secondary">{q.company}</Badge>
                      <Badge>{q.difficulty}</Badge>
                    </div>
                  </li>
                ))}
              </ul>
            </ScrollArea>
          </ResizablePanel>
          <ResizableHandle withHandle />
          <ResizablePanel defaultSize={70} className="p-6 overflow-y-auto">
            <h2 className="text-2xl font-semibold mb-4">{selected.question}</h2>
            <div className="prose max-w-none">
              <ReactMarkdown>
                {selected.answer}
              </ReactMarkdown>
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </main>
      <Footer />
    </div>
  );
};

export default MLFundamentals;
